import { useCallback, useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import { Header, Footer } from 'components/common';

import ProfileDefaultHeader from 'assets/images/profile-default-header.svg';
import Pen from 'assets/icons/pen.svg';
import UserDefaultImg from 'assets/images/user-default-pic.svg';

import EditProfile from 'components/Profile/EditProfile';
import MyAssets from 'components/Profile/MyAssets';
import ListedAssets from 'components/Profile/ListedAssets';
import CreateProfile from 'components/Profile/CreateProfile';
import Favourites from 'components/Profile/Favourites';
import { useAccount } from 'wagmi';
import { useToast } from 'components/common/Toast/ToastProvider';
import Activities from 'components/Profile/Activities';

const Profile = () => {
  const [activeRoute, setActiveRoute] = useState<string>('edit');

  const { address } = useAccount();
  const history = useNavigate();
  const toast = useToast();

  useEffect(() => {
    if (!address) {
      toast?.error('Please connect your wallet', 2500);
      history('/');
    }
  }, [address]);

  const { name } = useParams();

  useEffect(() => {
    if (name) setActiveRoute(name);
  }, [name]);

  function routeComponent({ route, routeName }: any) {
    return (
      <div
        onClick={() => {
          setActiveRoute(route);
          history(`/profile/${route}`);
        }}
        className={`text-white cursor-pointer whitespace-nowrap py-2 px-4 ${
          activeRoute === route ? 'rounded  bg-primary-2' : ''
        }`}
        aria-hidden="true"
      >
        {routeName}
      </div>
    );
  }

  const ActiveSettings = useCallback(
    ({ routeName, route }: any) => routeComponent({ routeName, route }),
    [activeRoute]
  );

  const routes = [
    {
      routeName: 'Edit Profile',
      route: 'edit',
    },
    {
      routeName: 'My Assets',
      route: 'assets',
    },
    {
      routeName: 'Listed Assets',
      route: 'listedAssets',
    },
    // {
    //   routeName: 'Favourites',
    //   route: 'favourites',
    // },
    // {
    //   routeName: 'My Offers',
    //   route: 'myOffers',
    // },
    {
      routeName: 'Activities',
      route: 'activities',
    },
    // {
    //   routeName: 'Bids',
    //   route: 'bids',
    // },
  ];

  return (
    <div className="bg-black">
      <Header />
      <div className="">
        <div className="">
          <div
            className="bg-cover min-h-profile-header relative"
            style={{
              backgroundImage: `url(${ProfileDefaultHeader})`,
            }}
          >
            <div className="absolute right-8 bottom-8 z-10 cursor-pointer">
              <img src={Pen} className="" alt="" />
            </div>
          </div>
        </div>

        <div className="mx-6 sm:mx-4 md:mx-8">
          <div className="grid md:grid-cols-4 sm:grid-cols-1 grid-rows-1">
            <div className="flex col-span-1 flex-col  items-center h-fit mt-4 lg:-mt-10 sm:-mt-4 p-6 pb-24 lg:m-6 sm:m-0 z-40 bg-gray-4 rounded-3xl">
              <div className="grid place-content-center rounded-full lg:w-40 lg:h-40 bg-grey-rgba sm:w-20 sm:h-20">
                <img
                  className="lg:w-16 lg:h-16 sm:w-8 sm:h-8"
                  src={UserDefaultImg}
                  alt=""
                />
              </div>

              <div className="mt-4 text-center">
                <p className="text-white text-2xl font-bold">Ahamefula </p>
                <p className="text-white text-base mt-1 font-normal">
                  {address!}
                </p>
                <p className="text-white text-sm mt-6 font-normal">
                  A wholesome farm owner in Santorini. Born and raised by King
                  Ahamefula.
                </p>
              </div>
            </div>

            <div className="md:col-span-3 sm:col-span-1">
              <div className="flex justify-around flex-wrap overflow-x-scroll mt-20 mx-8 ">
                {routes.map(({ route, routeName }) => (
                  <ActiveSettings
                    key={route}
                    route={route}
                    routeName={routeName}
                  />
                ))}
              </div>

              <div className="mt-12">
                {activeRoute === 'edit' ? <EditProfile /> : ''}
                {activeRoute === 'assets' ? <MyAssets /> : ''}
                {activeRoute === 'listedAssets' ? <ListedAssets /> : ''}
                {activeRoute === 'create' ? <CreateProfile /> : ''}
                {activeRoute === 'favourites' ? <Favourites /> : ''}
                {activeRoute === 'activities' ? <Activities /> : ''}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Profile;
